// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_search_input_container__W7mP6 {
  display: flex;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.style_search_select__f-jhT,
.style_search_input__W2KKw {
  border: none !important;
}

.style_productContainer__n5bUu {
  display: flex;
  gap: 25px;
}

.style_productContainer__n5bUu .style_leftpart__HDMFx {
  width: 65%;
}

.style_productContainer__n5bUu .style_rightpart__yyZMI {
  width: 33%;


}

.style_whiteContainer__JQnOZ {
  border: 1px solid rgb(209, 207, 207);
  border-radius: 10px;
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  padding: 6px;
}

.style_whiteContainer__JQnOZ input::placeholder,
.style_whiteContainer__JQnOZ textarea::placeholder {
  color: transparent;
  /* Hides the placeholder text by making it transparent */
}

.style_whiteContainer__JQnOZ h3 {
  font-size: 22px;
  color: black;
  font-weight: 600;
  margin-bottom: 16px;
}

.style_whiteContainer__JQnOZ input,
.style_whiteContainer__JQnOZ select,
.style_whiteContainer__JQnOZ textarea {
  background-color: #F8FAFF;
  color: rgb(53, 52, 52);
}

.style_imageContainer__gURyl {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  max-height: 600px;
  overflow: scroll;
  color: black;
  background: white;
  width: 47%;
  padding: 0px 10px;

}

.style_imageContainer__gURyl::-webkit-scrollbar {
  display: none;
}

.style_productsearchInput__OdfBp {
  width: 30%;
}

/* New table styles for Instorecatalog */
.style_catalogHeaderCard__5EJRv {
  width: 100%;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  border-radius: 22px;
  padding: 28px 28px 20px;
  margin-bottom: 24px;
}

.style_catalogHeaderTop__QhCxA {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}

.style_catalogTitle__8OlY7 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

.style_catalogSubtitle__k3L7u {
  margin: 6px 0 0;
  font-size: 14px;
  color: #6b7280;
}

.style_catalogActions__f93nu {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.style_catalogSearchInput__zrbw8 {
  min-width: 260px;
  max-width: 100%;
  width: 260px;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  padding: 12px 16px;
  background: #f8fafc;
  color: #111827;
}

.style_catalogButtonSecondary__bOgqn,
.style_catalogButtonPrimary__HrpGz,
.style_catalogButtonIcon__XwB5L {
  border-radius: 12px;
  padding: 11px 18px;
  font-weight: 600;
  transition: all 0.2s ease;
  cursor: pointer;
}

.style_catalogButtonSecondary__bOgqn {
  background: #f8fafc;
  border: 1px solid #d1d5db;
  color: #111827;
}

.style_catalogButtonSecondary__bOgqn:hover {
  background: #edf2f7;
}

.style_catalogButtonPrimary__HrpGz {
  background: #fb7d2d;
  border: none;
  color: #ffffff;
}

.style_catalogButtonPrimary__HrpGz:hover {
  background: #ea6d19;
}

.style_catalogButtonIcon__XwB5L {
  background: #ffffff;
  border: 1px solid #d1d5db;
  padding: 10px 12px;
}

.style_catalogCard__52HWM {
  width: 100%;
  background: #ffffff;
  border-radius: 22px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.style_tableScrollArea__t5kRs {
  width: 100%;
  /* leave space for header, filters and pagination - adjust as needed */
  max-height: calc(100vh - 260px);
  overflow-y: auto;
  overflow-x: auto;
  background: transparent;
}

.style_catalogTable__776u0 {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 10px;
  min-width: 900px;
}

.style_catalogTable__776u0 thead tr {
  background: #f8fafc;
}

.style_catalogTable__776u0 th {
  padding: 18px 16px;
  text-align: left;
  font-size: 14px;
  color: #111827;
  font-weight: 700;
  border-bottom: 1px solid #e5e7eb;
}

.style_catalogTable__776u0 td {
  padding: 18px 16px;
  vertical-align: middle;
  background: #ffffff;
  color: #374151;
}

.style_catalogTableRow__UBf2M {
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
  border-radius: 18px;
}

.style_catalogTableRow__UBf2M td:first-child {
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}

.style_catalogTableRow__UBf2M td:last-child {
  border-top-right-radius: 18px;
  border-bottom-right-radius: 18px;
}

.style_catalogTableRow__UBf2M:hover td {
  background: #f8fafc;
}

.style_catalogTable__776u0 tr td:first-child {
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}

.style_catalogTable__776u0 tr td:last-child {
  border-top-right-radius: 18px;
  border-bottom-right-radius: 18px;
}

.style_tableHead__k3n8p {
  position: sticky;
  top: 0;
  z-index: 10;
}

.style_thImage__77zuN {
  width: 100px;
}

.style_catalogTable__776u0 img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
}

.style_compactActions__4Ku0N {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 800px) {
  .style_productsearchInput__OdfBp { width: 100%; }
  .style_instoreTable__TbV0C th:nth-child(3), .style_instoreTable__TbV0C td:nth-child(3) { display: none; }
  .style_instoreTable__TbV0C th:nth-child(5), .style_instoreTable__TbV0C td:nth-child(5) { display: none; }
  .style_instoreTable__TbV0C img { width: 48px; height: 48px; }
}



.style_editContainer__jim79 {
  display: flex;
  gap: 10px;
}

.style_editContainerMobile__nnGq- {
  display: none;
}

.style_productDeleteIcon__RTvNe {
  color: "red";
  cursor: "pointer";
  font-size: "30px"
}

.style_productEditIcon__onrhw {
  height: 32px;
  width: 32px;
}

.style_productQRIcon__QWchS {
  cursor: "pointer";
  font-size: "30px"
}

@media screen and (max-width: 500px) {

  .style_imageContainer__gURyl {
    width: 90%;
  }

  .style_productContainer__n5bUu {
    display: block;
  }

  .style_productContainer__n5bUu .style_leftpart__HDMFx {
    width: 100%;
  }

  .style_productContainer__n5bUu .style_rightpart__yyZMI {
    width: 100%;
  }

  .style_whiteContainer__JQnOZ {
    margin-top: 15px;
  }

  .style_productsearchInput__OdfBp {
    width: 100%;
  }

  .style_editContainer__jim79 {
    display: none;
  }

  .style_productDeleteIcon__RTvNe {
    color: red;
    font-size: 25px;
  }

  .style_productEditIcon__onrhw {
    height: 24px;
    width: 24px;
  }

  .style_productQRIcon__QWchS {
    cursor: "pointer";
    font-size: "10px"
  }

  .style_editContainerMobile__nnGq- {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/catalog/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;;;AAGZ;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sEAAsE;EACtE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAsB,WAAW,EAAE;EACnC,yFAA+D,aAAa,EAAE;EAC9E,yFAA+D,aAAa,EAAE;EAC9E,iCAAoB,WAAW,EAAE,YAAY,EAAE;AACjD;;;;AAIA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;;EAEE;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB;EACF;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".search_input_container {\n  display: flex;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.search_select,\n.search_input {\n  border: none !important;\n}\n\n.productContainer {\n  display: flex;\n  gap: 25px;\n}\n\n.productContainer .leftpart {\n  width: 65%;\n}\n\n.productContainer .rightpart {\n  width: 33%;\n\n\n}\n\n.whiteContainer {\n  border: 1px solid rgb(209, 207, 207);\n  border-radius: 10px;\n  background-color: white;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 6px;\n}\n\n.whiteContainer input::placeholder,\n.whiteContainer textarea::placeholder {\n  color: transparent;\n  /* Hides the placeholder text by making it transparent */\n}\n\n.whiteContainer h3 {\n  font-size: 22px;\n  color: black;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n\n.whiteContainer input,\n.whiteContainer select,\n.whiteContainer textarea {\n  background-color: #F8FAFF;\n  color: rgb(53, 52, 52);\n}\n\n.imageContainer {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 20px;\n  max-height: 600px;\n  overflow: scroll;\n  color: black;\n  background: white;\n  width: 47%;\n  padding: 0px 10px;\n\n}\n\n.imageContainer::-webkit-scrollbar {\n  display: none;\n}\n\n.productsearchInput {\n  width: 30%;\n}\n\n/* New table styles for Instorecatalog */\n.catalogHeaderCard {\n  width: 100%;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);\n  border-radius: 22px;\n  padding: 28px 28px 20px;\n  margin-bottom: 24px;\n}\n\n.catalogHeaderTop {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.catalogTitle {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.catalogSubtitle {\n  margin: 6px 0 0;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.catalogActions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.catalogSearchInput {\n  min-width: 260px;\n  max-width: 100%;\n  width: 260px;\n  border: 1px solid #d1d5db;\n  border-radius: 12px;\n  padding: 12px 16px;\n  background: #f8fafc;\n  color: #111827;\n}\n\n.catalogButtonSecondary,\n.catalogButtonPrimary,\n.catalogButtonIcon {\n  border-radius: 12px;\n  padding: 11px 18px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.catalogButtonSecondary {\n  background: #f8fafc;\n  border: 1px solid #d1d5db;\n  color: #111827;\n}\n\n.catalogButtonSecondary:hover {\n  background: #edf2f7;\n}\n\n.catalogButtonPrimary {\n  background: #fb7d2d;\n  border: none;\n  color: #ffffff;\n}\n\n.catalogButtonPrimary:hover {\n  background: #ea6d19;\n}\n\n.catalogButtonIcon {\n  background: #ffffff;\n  border: 1px solid #d1d5db;\n  padding: 10px 12px;\n}\n\n.catalogCard {\n  width: 100%;\n  background: #ffffff;\n  border-radius: 22px;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);\n  overflow: hidden;\n}\n\n.tableScrollArea {\n  width: 100%;\n  /* leave space for header, filters and pagination - adjust as needed */\n  max-height: calc(100vh - 260px);\n  overflow-y: auto;\n  overflow-x: auto;\n  background: transparent;\n}\n\n.catalogTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0 10px;\n  min-width: 900px;\n}\n\n.catalogTable thead tr {\n  background: #f8fafc;\n}\n\n.catalogTable th {\n  padding: 18px 16px;\n  text-align: left;\n  font-size: 14px;\n  color: #111827;\n  font-weight: 700;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.catalogTable td {\n  padding: 18px 16px;\n  vertical-align: middle;\n  background: #ffffff;\n  color: #374151;\n}\n\n.catalogTableRow {\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);\n  border-radius: 18px;\n}\n\n.catalogTableRow td:first-child {\n  border-top-left-radius: 18px;\n  border-bottom-left-radius: 18px;\n}\n\n.catalogTableRow td:last-child {\n  border-top-right-radius: 18px;\n  border-bottom-right-radius: 18px;\n}\n\n.catalogTableRow:hover td {\n  background: #f8fafc;\n}\n\n.catalogTable tr td:first-child {\n  border-top-left-radius: 18px;\n  border-bottom-left-radius: 18px;\n}\n\n.catalogTable tr td:last-child {\n  border-top-right-radius: 18px;\n  border-bottom-right-radius: 18px;\n}\n\n.tableHead {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.thImage {\n  width: 100px;\n}\n\n.catalogTable img {\n  width: 72px;\n  height: 72px;\n  object-fit: cover;\n  border-radius: 16px;\n  border: 1px solid #e5e7eb;\n}\n\n.compactActions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media screen and (max-width: 800px) {\n  .productsearchInput { width: 100%; }\n  .instoreTable th:nth-child(3), .instoreTable td:nth-child(3) { display: none; }\n  .instoreTable th:nth-child(5), .instoreTable td:nth-child(5) { display: none; }\n  .instoreTable img { width: 48px; height: 48px; }\n}\n\n\n\n.editContainer {\n  display: flex;\n  gap: 10px;\n}\n\n.editContainerMobile {\n  display: none;\n}\n\n.productDeleteIcon {\n  color: \"red\";\n  cursor: \"pointer\";\n  font-size: \"30px\"\n}\n\n.productEditIcon {\n  height: 32px;\n  width: 32px;\n}\n\n.productQRIcon {\n  cursor: \"pointer\";\n  font-size: \"30px\"\n}\n\n@media screen and (max-width: 500px) {\n\n  .imageContainer {\n    width: 90%;\n  }\n\n  .productContainer {\n    display: block;\n  }\n\n  .productContainer .leftpart {\n    width: 100%;\n  }\n\n  .productContainer .rightpart {\n    width: 100%;\n  }\n\n  .whiteContainer {\n    margin-top: 15px;\n  }\n\n  .productsearchInput {\n    width: 100%;\n  }\n\n  .editContainer {\n    display: none;\n  }\n\n  .productDeleteIcon {\n    color: red;\n    font-size: 25px;\n  }\n\n  .productEditIcon {\n    height: 24px;\n    width: 24px;\n  }\n\n  .productQRIcon {\n    cursor: \"pointer\";\n    font-size: \"10px\"\n  }\n\n  .editContainerMobile {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search_input_container": `style_search_input_container__W7mP6`,
	"search_select": `style_search_select__f-jhT`,
	"search_input": `style_search_input__W2KKw`,
	"productContainer": `style_productContainer__n5bUu`,
	"leftpart": `style_leftpart__HDMFx`,
	"rightpart": `style_rightpart__yyZMI`,
	"whiteContainer": `style_whiteContainer__JQnOZ`,
	"imageContainer": `style_imageContainer__gURyl`,
	"productsearchInput": `style_productsearchInput__OdfBp`,
	"catalogHeaderCard": `style_catalogHeaderCard__5EJRv`,
	"catalogHeaderTop": `style_catalogHeaderTop__QhCxA`,
	"catalogTitle": `style_catalogTitle__8OlY7`,
	"catalogSubtitle": `style_catalogSubtitle__k3L7u`,
	"catalogActions": `style_catalogActions__f93nu`,
	"catalogSearchInput": `style_catalogSearchInput__zrbw8`,
	"catalogButtonSecondary": `style_catalogButtonSecondary__bOgqn`,
	"catalogButtonPrimary": `style_catalogButtonPrimary__HrpGz`,
	"catalogButtonIcon": `style_catalogButtonIcon__XwB5L`,
	"catalogCard": `style_catalogCard__52HWM`,
	"tableScrollArea": `style_tableScrollArea__t5kRs`,
	"catalogTable": `style_catalogTable__776u0`,
	"catalogTableRow": `style_catalogTableRow__UBf2M`,
	"tableHead": `style_tableHead__k3n8p`,
	"thImage": `style_thImage__77zuN`,
	"compactActions": `style_compactActions__4Ku0N`,
	"instoreTable": `style_instoreTable__TbV0C`,
	"editContainer": `style_editContainer__jim79`,
	"editContainerMobile": `style_editContainerMobile__nnGq-`,
	"productDeleteIcon": `style_productDeleteIcon__RTvNe`,
	"productEditIcon": `style_productEditIcon__onrhw`,
	"productQRIcon": `style_productQRIcon__QWchS`
};
export default ___CSS_LOADER_EXPORT___;
